import {BaseCaller} from './api';

export default class LocationApi {

    private caller: BaseCaller;

    constructor(caller: BaseCaller) {
        this.caller = caller;
    }

    public history(id: number,startDate: string, endDate: string): Promise<any> {
        return this.caller.get(`driver/${id}/location/history/${startDate}/${endDate}`);
    };
    public historyVisit(id: number,startDate: string, endDate: string): Promise<any> {
        return this.caller.get(`driver/${id}/visit/history/${startDate}/${endDate}`);
    };
    public notificationHistory(id: number): Promise<any> {
        return this.caller.get(`driver/${id}/notification/history`);
    };
    public notificationHistoryRaces(id: number): Promise<any> {
        return this.caller.get(`opportunity/${id}/notification/history`);
    };

    
}




// WEBPACK FOOTER //
// ./src/api/location-api.ts